import { useEffect } from 'react';

const clearColorSchemeClasses = () => {
    document.body.classList.forEach((className) => {
        if (/^color-scheme-/.test(className)) {
            document.body.classList.remove(className);
        }
    });
};

export const useSetColorScheme = ({ page }) => {
    useEffect(() => {
        if (!page) {
            return;
        }

        const { colorSchemeCSSClass } = page;

        document.body.classList.add(`color-scheme-${colorSchemeCSSClass || 'default'}`);

        return () => {
            clearColorSchemeClasses();
        };
    }, [page]);
};
